<template>
  <div
    @click="onClickCard"
    class="luggage-card"
    :class="{ 'luggage-card--disable': !clickable, 'luggage-card--full': disable }"
    :style="{ marginBottom }"
  >
    <div class="luggage-card__icon">
      <img v-if="age_type === 'adult'" src="@/assets/img/adult-icon.svg" alt="">
      <img v-if="age_type === 'child'" src="@/assets/img/child-icon.svg" alt="">
    </div>
    <div v-if="weight" class="luggage-card__text">{{ weight }} KG</div>
    <div v-if="price" class="luggage-card__price">{{ price }} $</div>
  </div>
</template>

<script>
export default {
  name: 'AppLuggageCard',
  props: {
    age_type: {
      type: String,
      default: '',
    },
    weight: {
      type: Number,
      default: 0,
    },
    price: {
      type: Number, String,
    },
    clickable: {
      type: Boolean,
      default: true,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    marginBottom: {
      type: String,
      default: '10px',
    }
  },
  methods: {
    onClickCard() {
      if (this.clickable) this.$emit('clickCard')
    }
  }
}
</script>

<style scoped lang="sass">
.luggage-card
  position: relative
  display: flex
  justify-content: flex-start
  align-items: center
  gap: 10px
  padding: 10px
  border: 1px solid #dcdcdc
  border-radius: 10px
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08)
  background-color: #fff
  cursor: pointer
  transition: border-color 0.3s

  &:hover(:not(.luggage-card--disable))
    border-color: #b8b8b8

.luggage-card--disable
  cursor: default

.luggage-card__icon
  display: inline-flex
  align-items: flex-end
  justify-content: center
  gap: 2px
  min-width: 38px
  height: 38px
  padding: 8px
  border: 1px solid rgba(0, 0, 0, 0.1)
  border-radius: 4px
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1)
  background: linear-gradient(180deg, #fff 0%, #f4f4f4 100%)
  transition: border 0.3s, background-color 0.3s

.luggage-card__text
  font-weight: 500

.luggage-card__price
  position: absolute
  right: 10px
  top: 50%
  transform: translateY(-50%)
  font-weight: 500

.luggage-card--full
  opacity: 0.6
  pointer-events: none
</style>